import React, { useState, useRef, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import Form from 'jd-library/Form';
import {setAuditObject} from '../../actions/products';
import {checkProductStatus} from '../../utills';
import './audit-product.scss';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel'
import AuditProductRadioGroup from '../../common/ui/organisms/auditProductRadioGroup';

const radioClickHandle = (options = {}) => {
    let {props, event, value, checkBoxOptions} = options;
    if(event.target.checked) {
        props.setAuditObject({
            minCorrectTextArea: '',
            errWithDetTextArea: '',
            minCorrectErr: false,
            errWithDetErr: false,
            unSelectedErr: false,
            checkboxErr: false,
            rejectionMessage: '',
            brandedProductId: '',
            rejectionErr:false,
            brandedErr: false,
            
            checkBoxData: JSON.parse(JSON.stringify(checkBoxOptions)),
            checkedValue: value
        });

    }
}

const numberReg = /^\d{0,10}$/;

const getCheckboxes = (options = {}) => {
    let {checkBoxData, props} = options;
    let result = [];
    checkBoxData.forEach((item, index) => {
        result.push( <>
            <Form.Check className='check-input-row' labelClass = 'label-row' rippleColor='rgba(33, 37, 41, .1)' onChange = {(e) => {
                let checkBoxData = [
                    ...props.auditData.checkBoxData
                ];
                checkBoxData[index].value = e.target.checked;
                checkBoxData[index].textBoxValue = '';
                checkBoxData[index].error = false;
                props.setAuditObject({
                    checkBoxData,
                    checkboxErr: false
                });
            }} label={item.name} checked={item.value}
            disabled = {item.disabled}/>
            { item.showCommentBox && item.value ? <Form.TextArea className = {'others-text-area'} variant={item.error ? 'invalid' : ''} value={item.textBoxValue} onChange={e => {
                let checkBoxData = [
                    ...props.auditData.checkBoxData
                ];
                checkBoxData[index].textBoxValue = e.target.value;
                checkBoxData[index].error = false;
                props.setAuditObject({
                    checkBoxData
                });
            }} placeholder="Enter Details" /> : null}
            { item.value && item.error ? <Form.FeedBack className = {'others-text-area'} variant='invalid'>{'Enter Details'}</Form.FeedBack>
                : null}
        </>);
    });
    return result;
};

let timeoutInMiliseconds = 1000 * 60 * 30;
let timeoutId;

const AuditProduct = props => {
    
    let {minCorrectTextArea, checkedValue, minCorrectErr, unSelectedErr, checkBoxData, checkboxErr, rejectionErr, brandedErr} = props.auditData;
    const [showSampleDis, setSampleDis] = useState(false);
    const [rejectionDetails,setRejectionDetails] = useState('');
    const [brandedProductId,setBrandedProductId] = useState('');
    const [majorErrComment, setMajorErrComment] = useState(props.showAuditData?.comment)
    const isIPhone = props.deviceData.isIphone || props.isJdSourceIOS;
    const isCorrector = props.loggedUser?.subType === "CORRECTOR"
    
    useEffect(()=>{
        if(props.showAuditData){
            if(props.showAuditData.auditDisposition == 'NO_ERROR'){
                props.setAuditObject({
                    checkedValue :'allGood'
                });
            }
            else if(props.showAuditData.auditDisposition == 'MINOR_ERROR'){
                minCorrectTextArea = props.showAuditData.comment;
                props.setAuditObject({
                    checkedValue : 'minCorrect',
                    minCorrectTextArea: minCorrectTextArea
                });
            }
            else if(props.showAuditData.auditDisposition == 'MAJOR_ERROR'){
                props.setAuditObject({
                    checkedValue : 'errWithDet'
                });
            }
            else if(props.showAuditData.auditDisposition == 'PASSED_BY_SAMPLING') {
                setSampleDis(true);
                props.setAuditObject({
                    checkedValue : 'passedBySample'
                });
            }
            else if(props.showAuditData.auditDisposition == 'NOT_ELIGIBLE_FOR_QC') {
                props.setAuditObject({
                    checkedValue : 'notEligibleForQC'
                });
            }
        }
    },[props.showAuditData])
    useEffect(()=>{
        if(props.isAddProduct){
            props.setAuditObject({
                checkedValue : 'errWithDet'
            });
        }
    },{})
    const destroyTimers = () => {
        window.clearTimeout(timeoutId);
        document.removeEventListener("mousemove", resetTimer);
        document.removeEventListener("mousedown", resetTimer);
        document.removeEventListener("keypress", resetTimer);
        document.removeEventListener("touchmove", resetTimer);
    };

    let startTimer;
    const doInactive = () => {
        checkProductStatus({
            token: props.token,
            productId: props.productId,
            timeStamp: props.productData.audtTimeStamp,
            cb: (data) => {
                data = data.data;
                if (data.status == 1) {
                    if(data.isAlreadyAudited) {
                        props.updateTimeoutModal(true);
                        props.updateAuditMsg('Product details has got updated while you were auditing. Click on continue to get the updated version of the product');
						props.updateSaveProdConflict('alreadyAudited');
                        destroyTimers();
                    } else if(data.isOwnerEdited) {
                        props.updateTimeoutModal(true);
                        props.updateAuditMsg('Product details has been edited by the Owner while you were auditing. Click on continue to get the updated version of the product');
                        props.updateSaveProdConflict('ownerEdited');
                        destroyTimers();
                    } else {
                        startTimer();
                    }
                    return;
                }
                props.updateTimeoutModal(true);
            }
        });
    };
    startTimer = () => {
        timeoutId = window.setTimeout(doInactive, timeoutInMiliseconds)
    };
    const resetTimer = () => {
        window.clearTimeout(timeoutId)
        startTimer();
    };

    const setupTimers = () => {
        document.addEventListener("mousemove", resetTimer, false);
        document.addEventListener("mousedown", resetTimer, false);
        document.addEventListener("keypress", resetTimer, false);
        document.addEventListener("touchmove", resetTimer, false);
        startTimer();
    };
    useEffect(() => {
        props.setAuditObject({
            textBoxValue: props.showAuditData?.comment || ""
        });
        setupTimers();
        return () => {
            destroyTimers();
        };
    }, []);

    useEffect(() => {
        if(!props.auditData.checkBoxData && props.checkBoxOptions) {
            props.setAuditObject({
                checkBoxData: JSON.parse(JSON.stringify(props.checkBoxOptions))
            });
        }
    }, [props.checkBoxOptions]);

    const handleRejectionMessage = (e) => {
        setRejectionDetails(e.target.value);
        props.setAuditObject({ rejectionMessage:e.target.value });
    }

    const handleProductIdChange = (e) => {
        if (!numberReg.test(e.target.value)) {
            return;
        }
        setBrandedProductId(e.target.value);
        props.setAuditObject({ brandedProductId : e.target.value });
    }

    const isObjectionable = props.productData?.isObjectionable;
    const isSellOnline = props.productData?.isSellOnline;
    const isPackageLabel = props.productData?.labelImageUrl || props.productData?.labelFrontImageUrl;
    const productOrService = props.productData?.categoryType
    return (
        <div className = {'audit-section'}>
            <div className = {'header'}>
                {(productOrService == 'service') ? 'Audit Service' : (props.isMrpCompliance ? "Audit Inventory Batch" : "Audit Product")}
            </div>
            <Form>
                {!props.productData?.isTemplate && !props?.isMrpCompliance ? <>
                    <Form.Radio className='input-row' name='radiobtn' onChange={e => {
                        radioClickHandle({props, event: e, value:'allGood', checkBoxOptions: props.checkBoxOptions});
                    }} label={(productOrService == 'service') ? 'Service has No Errors' : 'Product has No Errors'} labelClass='label-row' checked = {checkedValue == 'allGood'} disabled={props.isAddProduct}/>
                    <Form.Radio className='input-row' name='radiobtn' onChange={e => {
                        radioClickHandle({props, event: e, value:'minCorrect', checkBoxOptions: props.checkBoxOptions});
                    }} label={(productOrService == 'service') ? 'Service has Minor Errors' : 'Product has Minor Errors'} labelClass='label-row' checked = {checkedValue == 'minCorrect'}disabled={props.isAddProduct}/>
                    {
                        checkedValue == 'minCorrect' ?
                        <AuditProductRadioGroup 
                            checkBoxOptions={checkBoxData}
                            errType={checkedValue}
                            key={checkedValue}
                        />
                        : null
                    }
                    {
                        checkedValue == 'minCorrect' ?
                        <Form.Group className = {'text-area'}>
                            <Form.TextArea className = {'min-error-text-area'} variant = {minCorrectErr ? 'invalid' : ''} value={minCorrectTextArea} onChange={e => {
                                props.setAuditObject({
                                    minCorrectErr: false,
                                    minCorrectTextArea: e.target.value
                                });
                            }} placeholder="Enter Details" />
                            { minCorrectErr ? <Form.FeedBack variant='invalid'>Enter Details</Form.FeedBack> : null}
                        </Form.Group> : null
                    }
                    <Form.Radio className='input-row' name='radiobtn' onChange={e => {
                        radioClickHandle({props, event: e, value:'errWithDet', checkBoxOptions: props.checkBoxOptions});
                        setTimeout(() => {
                            window.scrollTo(0,document.body.scrollHeight);
                        },100);
                    }} label={(productOrService == 'service') ? 'Service has Major Errors' : 'Product has Major Errors'} labelClass='label-row' checked = {checkedValue == 'errWithDet'}/>
                    {
                        checkedValue == 'errWithDet' ?
                        <>
                            <AuditProductRadioGroup 
                                checkBoxOptions={checkBoxData} 
                                errType={checkedValue} 
                                key={checkedValue} 
                            />
                            <Form.Group className = {'text-area'}>
                                <Form.TextArea 
                                    className = {'others-text-area-major-err'} 
                                    value={majorErrComment} 
                                    onChange={(e)=>{
                                        setMajorErrComment(e.target.value)
                                        props.setAuditObject({
                                            textBoxValue: e.target.value
                                        });
                                    }}
                                    placeholder="Enter Details"
                                />
                            </Form.Group>
                        </>
                        : null
                    }
                    {(!isObjectionable && isSellOnline) ? <Form.Radio className='input-row' name='radiobtn' onChange={e => {
                        radioClickHandle({props, event: e, value:'mergeWithBrandedProduct', checkBoxOptions: props.checkBoxOptions});
                        setTimeout(() => {
                            window.scrollTo(0,document.body.scrollHeight);
                        },100);
                    }} label='Merge with Branded Product' labelClass='label-row' checked = {checkedValue == 'mergeWithBrandedProduct'} disabled={props.isAddProduct}/> : null}
                    {(!isObjectionable && isSellOnline) && checkedValue == 'mergeWithBrandedProduct' ? 
                    <InputWithMovingLabel
                        label={'Enter Branded Product ID'}
                        errorMessage={brandedErr}
                        holderClass={`details-container marginB10`}
                        type={isIPhone ? "number" : "tel"}
                        input={{
                            value: brandedProductId,
                            onChange: e => handleProductIdChange(e, 'textarea'),
                            onBlur: () => {
                                props.setAuditObject({ brandedErr : false });
                            },
                            onFocus: () => {
                                props.setAuditObject({ brandedErr : false });
                            }
                        }}
                    />                    
                    : null}
                    {!isObjectionable ? <Form.Radio className='input-row' name='radiobtn' onChange={e => {
                        radioClickHandle({props, event: e, value:'notEligibleForQC', checkBoxOptions: props.checkBoxOptions});
                    }} label='Not Eligible for QC' labelClass='label-row' checked = {checkedValue == 'notEligibleForQC'} disabled={props?.isAddProduct}/>
                    : null}
                </> :  <Form.Radio className='input-row' name='radiobtn' onChange={e => {
                        radioClickHandle({props, event: e, value:'approveUpdateProductBank', checkBoxOptions: props.checkBoxOptions});
                    }} label='Approve and Update Product Bank' labelClass='label-row' checked = {checkedValue == 'approveUpdateProductBank'} disabled={props.isAddProduct}/>}
                {(!isObjectionable && (isSellOnline || props?.productData?.isTemplate)) ?<Form.Radio className='input-row' name='radiobtn' onChange={e => {
                    radioClickHandle({props, event: e, value:'productRejected', checkBoxOptions: props.checkBoxOptions});
                    setTimeout(() => {
                        window.scrollTo(0,document.body.scrollHeight);
                    },100);
                }} label={!props.isMrpCompliance ? 'Product Rejected' : 'Reject'} labelClass='label-row' checked = {checkedValue == 'productRejected'} disabled={props?.isAddProduct}/> : null}
                {!isObjectionable && isPackageLabel && !props.isMrpCompliance ?<Form.Radio className='input-row' name='radiobtn' onChange={e => {
                    radioClickHandle({props, event: e, value:'PRODUCT_REJECTED_FOR_LABEL', checkBoxOptions: props.checkBoxOptions});
                    setTimeout(() => {
                        window.scrollTo(0,document.body.scrollHeight);
                    },100);
                }} label='Reject Product and Product Packaging Label' labelClass='label-row' checked = {checkedValue == 'PRODUCT_REJECTED_FOR_LABEL'} disabled={props?.isAddProduct}/> : null}
                {(!isObjectionable && (isSellOnline || props?.productData?.isTemplate)) && (checkedValue == 'productRejected' || checkedValue == 'PRODUCT_REJECTED_FOR_LABEL') ?
                <InputWithMovingLabel
                    label={'Enter Details'}
                    errorMessage={rejectionErr}
                    holderClass={'details-container'}
                    as={'textarea'}
                    input={{
                        value: rejectionDetails,
                        onChange: e => handleRejectionMessage(e, 'textarea'),
                        onBlur: () => {
                            props.setAuditObject({ rejectionErr : false });
                        },
                        onFocus: () => {
                            props.setAuditObject({ rejectionErr : false });
                        }
                    }}
                />
                : null}
                { unSelectedErr ? <Form.FeedBack className = {'no-selection-err'} variant='invalid'>Select a Value</Form.FeedBack> : null}
                {showSampleDis ? <Form.Radio className='input-row' name='radiobtn' onChange={e => {
                    radioClickHandle({props, event: e, value:'passedBySample', checkBoxOptions: props.checkBoxOptions});
                    setTimeout(() => {
                        window.scrollTo(0,document.body.scrollHeight);
                    },100);
                }} label='No Errors - Passed by Sampling' labelClass='label-row' checked = {checkedValue == 'passedBySample'}/>: null}
            </Form>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        auditData: state.products.auditData,
        checkBoxOptions: state.products.editProduct?.checkBoxOptions,
        variantId: state.products.editProduct?.variantId,
        token: state.session.token,
        productData: state.products.editProduct,
        deviceData: state.deviceData,
        productId: state.products?.editProduct?.productId,
        loggedUser: state.session.user.loggedUser
    };
};

export default connect(mapStateToProps, {setAuditObject})(AuditProduct);